var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "list-search" }, [
    _c("form", [
      _c("div", { staticClass: "row row-clear-sm-6-md-4" }, [
        _c("div", { staticClass: "col-sm-6 col-md-4" }, [
          _c("div", { staticClass: "form-group" }, [
            _c("label", { staticClass: "sr-only" }, [_vm._v("Keywords")]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.stateKeywords,
                  expression: "stateKeywords",
                },
              ],
              staticClass: "form-control",
              attrs: {
                name: "keywords",
                type: "text",
                placeholder: "Keywords",
              },
              domProps: { value: _vm.stateKeywords },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.stateKeywords = $event.target.value
                },
              },
            }),
          ]),
        ]),
        _vm._v(" "),
        _vm.$userIsGlobalAdmin && _vm.regionOptions.length > 1
          ? _c("div", { staticClass: "col-sm-6 col-md-4" }, [
              _c(
                "div",
                { staticClass: "form-group" },
                [
                  _c("label", { staticClass: "sr-only" }, [_vm._v("Region")]),
                  _vm._v(" "),
                  _c("selectize", {
                    ref: "regions",
                    staticClass: "selectize selectize-multiple",
                    attrs: {
                      multiple: "",
                      name: "region",
                      placeholder: "Region",
                      options: _vm.regionOptions,
                    },
                    model: {
                      value: _vm.stateRegions,
                      callback: function ($$v) {
                        _vm.stateRegions = $$v
                      },
                      expression: "stateRegions",
                    },
                  }),
                ],
                1
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        !_vm.$userIsClient
          ? _c("div", { staticClass: "col-sm-6 col-md-4" }, [
              _c("div", { staticClass: "form-group" }, [
                _c("label", { staticClass: "sr-only" }, [_vm._v("Due")]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "input-group" },
                  [
                    _c("flatpickr", {
                      staticClass: "form-control",
                      attrs: {
                        config: _vm.flatPickerDateConfig,
                        placeholder: "Date",
                        name: "date_range",
                      },
                      model: {
                        value: _vm.dateRange,
                        callback: function ($$v) {
                          _vm.dateRange = $$v
                        },
                        expression: "dateRange",
                      },
                    }),
                    _vm._v(" "),
                    _vm._m(0),
                    _vm._v(" "),
                    _vm._m(1),
                  ],
                  1
                ),
              ]),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.$userIsManager
          ? _c("div", { staticClass: "col-sm-6 col-md-4" }, [
              _c(
                "div",
                { staticClass: "form-group" },
                [
                  _c("label", { staticClass: "sr-only" }, [
                    _vm._v(
                      _vm._s(_vm._f("sentenceCase")(_vm.$starLabelPlural))
                    ),
                  ]),
                  _vm._v(" "),
                  _c("selectize", {
                    ref: "talent",
                    staticClass: "selectize selectize-multiple",
                    attrs: {
                      multiple: "",
                      name: "talent",
                      placeholder: _vm.$options.filters.sentenceCase(
                        _vm.$starLabel
                      ),
                      options: _vm.talentOptions,
                      "pre-load": true,
                      "fetch-results": _vm.fetchTalentCallback,
                      "fetch-more-results": _vm.fetchMoreTalentCallback,
                    },
                    model: {
                      value: _vm.stateTalent,
                      callback: function ($$v) {
                        _vm.stateTalent = $$v
                      },
                      expression: "stateTalent",
                    },
                  }),
                ],
                1
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.$userIsAdmin
          ? _c("div", { staticClass: "col-sm-6 col-md-4" }, [
              _c("div", { staticClass: "form-group" }, [
                _c("label", { staticClass: "sr-only" }, [
                  _vm._v("Request Number"),
                ]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.stateId,
                      expression: "stateId",
                    },
                  ],
                  staticClass: "form-control",
                  attrs: {
                    name: "id",
                    type: "text",
                    placeholder: "Request Number",
                  },
                  domProps: { value: _vm.stateId },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.stateId = $event.target.value
                    },
                  },
                }),
              ]),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { class: _vm.buttonClass }, [
          _c(
            "div",
            { staticClass: "form-group" },
            [
              _vm._t("button"),
              _vm._v(" "),
              _c("div", { staticClass: "clearfix" }),
            ],
            2
          ),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "span",
      { staticClass: "input-group-addon", attrs: { "data-toggle": "" } },
      [_c("i", { staticClass: "fa fa-calendar" })]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "span",
      { staticClass: "input-group-addon", attrs: { "data-clear": "" } },
      [_c("i", { staticClass: "fa fa-times" })]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }